import { render, staticRenderFns } from "./notificationSendTalk.vue?vue&type=template&id=17ab9eda"
import script from "./notificationSendTalk.vue?vue&type=script&lang=js"
export * from "./notificationSendTalk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports